import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayPanelComponent } from './overlay-panel.component';
import { BackdropModule } from '../backdrop';



@NgModule({
  declarations: [OverlayPanelComponent],
  imports: [
    CommonModule,
    BackdropModule
  ],
  exports: [
    OverlayPanelComponent
  ]
})
export class OverlayPanelModule { }
